<template>
  <v-app-bar
    app
    density="compact">
    <img
      data-cy="main-logo"
      id="logo"
      alt="logo"
      src="../../../assets/images/logo.png"
      srcset="../../../assets/images/logo-2.png 2x ../../../assets/images/logo-3.png 3x"
      @click="mainStore.leaveSpace()" />

    <div
      v-if="axiosStore.savingInBackground"
      data-cy="background-saving">
      Elemente werden gespeichert, bitte verlassen sie die Seite nicht
    </div>

    <v-spacer />

    <div v-if="isAllowedSupport">
      <v-btn @click="undefinedFunction()">Test Error</v-btn>
    </div>

    <v-spacer />

    <v-toolbar-items>
      <span v-if="mainStore.copyData.id"
        >Kopiertes Element: {{ mainStore.copyData.name }}</span
      >
      <CalculationChecker v-if="isAllowedSupport" />
      <FormelChecker v-if="isAllowedSupport" />
      <SupportAccess v-if="isAllowedSupport" />
      <language-switcher color="white" />
      <user-menu />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script setup>
import CalculationChecker from "../tools/CalculationChecker.vue";
import FormelChecker from "../tools/FormelChecker.vue";
import LanguageSwitcher from "../tools/LanguageSwitcher.vue";
import SupportAccess from "../tools/SupportAccess.vue";
import UserMenu from "./UserMenu.vue";
import { computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";
import { useSpaceStore } from "@/stores/spaceStore";
import { useMainStore } from "@/stores/mainStore";
import { useAxiosStore } from "@/stores/axiosStore";

const authStore = useAuthStore();
const spaceStore = useSpaceStore();
const mainStore = useMainStore();
const axiosStore = useAxiosStore();

const router = useRouter();

const isAllowedSupport = computed(() =>
  authStore.superUser.includes(authStore.user?.email)
);
</script>

<style scoped>
.v-toolbar {
  padding: 0 0 0 60px !important;
  background: linear-gradient(90deg, #0d0d0d 0%, #134d7d 100%) !important;
  box-shadow: none;
}

.v-toolbar-items {
  color: white;
  font-size: 16px;
}
</style>
